/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KahootLeaderItem } from './KahootLeaderItem';
import type { PollOption } from './PollOption';
import type { PollTallyItem } from './PollTallyItem';
/**
 * Presenter's competitive-quiz game view.
 */
export type KahootAdminState = {
    joinCode?: string;
    joinUrl?: string;
    qrPng?: string;
    phase?: KahootAdminState.phase;
    questionId?: string;
    question?: string;
    options?: Array<PollOption>;
    /**
     * Only on reveal/leaderboard.
     */
    correctKeys?: Array<string>;
    timeLimitS?: number;
    answerCount?: number;
    tally?: Array<PollTallyItem>;
    participantCount?: number;
    leaderboard?: Array<KahootLeaderItem>;
};
export namespace KahootAdminState {
    export enum phase {
        LOBBY = 'lobby',
        QUESTION = 'question',
        REVEAL = 'reveal',
        LEADERBOARD = 'leaderboard',
        ENDED = 'ended',
    }
}

